import React, { useMemo } from 'react'

import { Modal } from 'react-bootstrap'
import { TableV2 } from 'src/components'

interface IItemPriceError {
  name: string
  price: number
  defaultPrice: number
}

interface IOrderItemsPriceWithErrorProps {
  show: boolean
  repeat: boolean
  items: IItemPriceError[]
  onHide: () => void
}

const OrderItemsPriceWithError = ({
  show,
  repeat,
  items,
  onHide,
}: IOrderItemsPriceWithErrorProps) => {
  const headers: ITableHeader[] = useMemo(() => {
    return [
      {
        show: true,
        label: 'Ítem',
        type: 'text',
        value: ['name'],
      },
      {
        show: !repeat,
        label: 'Precio asignado',
        type: 'currency',
        value: ['price'],
      },
      {
        show: !repeat,
        label: 'Precio esperado',
        type: 'currency',
        value: ['defaultPrice'],
      },
      {
        show: repeat,
        label: 'Precio asignado',
        type: 'number',
        value: ['price'],
      },
      {
        show: repeat,
        label: 'Cantidad',
        type: 'number',
        value: ['defaultPrice'],
      },
    ]
  }, [repeat])

  return (
    <Modal show={show} centered onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          Se detectaron ítems con {!repeat ? 'precios no autorizados' : 'duplicaciones'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TableV2
          // @ts-ignore
          headers={headers}
          items={items}
        />
      </Modal.Body>
    </Modal>
  )
}
export default OrderItemsPriceWithError
